import React from 'react';
import { Card } from '../ui/Card';
import { BookOpenIcon } from 'lucide-react';
export function ClassesTab() {
  return <div data-id="element-251">
      <Card title="Enrolled Classes" data-id="element-252">
        <div className="flex items-center gap-3 mb-4" data-id="element-253">
          <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center" data-id="element-254">
            <BookOpenIcon className="w-5 h-5 text-purple-600" data-id="element-255" />
          </div>
          <div data-id="element-256">
            <h3 className="font-medium" data-id="element-257">No Classes</h3>
            <p className="text-sm text-gray-500" data-id="element-258">
              This contact is not enrolled in any classes
            </p>
          </div>
        </div>
        <button className="text-blue-600 hover:text-blue-800 text-sm font-medium" data-id="element-259">
          + Enroll in Class
        </button>
      </Card>
    </div>;
}